// extracted by mini-css-extract-plugin
export default {"container":"xI-z","innerContainer":"yI-z","multipleLines":"zI-z","heading":"AI-z","content":"BI-z","linkColor":"CI-z"};